import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { UserDialogComponent } from '../user-dialog/user-dialog.component';
import { NotificationService } from 'src/services/notification.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  users: Array<any>;
  currentUser: any;
  adminUser: any;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    @Inject('MIDIA_ENDPOINT') public midiaEndpoint: string,
    private snackbar: MatSnackBar,
    private router: Router,
    private notificationService: NotificationService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('token'));
  }

  ngOnInit(): void {
    this.getUsers();
    this.getAdminUser();
  }

  openUserDialog(user = null) {
    if((this.currentUser.signature_status == 'ACTIVE' || this.currentUser.signature_status == 'TRIAL')){
      
      if(user === null || (this.currentUser.id !== user.id && user.email !== this.adminUser && this.currentUser.is_admin == 'true')) {

        const options = {
          disableClose: true,
          width: '800px',
          data: { user }
        }
        this.dialog.open(UserDialogComponent, options)
          .afterClosed()
          .subscribe(
            result => {
              if (result)
                this.getUsers();
            }
          );    
      }else{
        if(this.currentUser.email == user.email){

          if(!confirm('Para fazer alterações na sua conta, utilize o menu "Meu Perfil". Deseja ir para lá agora?'))
            return;

          setTimeout(() => {
            this.router.navigate(['/recruiter/account']);
          }, 800); 

        }else{
         
            this.snackbar.open('Você não tem permissão para alterar essa conta.', 'OK', { duration: 3000 });
         
        } 
      }

    }else{

      this.notificationService.showAccountActivationMessage();
          
    } 

  }

  getUsers() {

    const data = {
      companyId: this.currentUser.company_id
    }
    this.http.list('user', data)
      .subscribe(
        (result: any) => {
          this.users = result.data;
          // console.log(result.data);
        },
        err => this.errorReport.showMessage(err)
      )

  }

  deleteUser(args, user) {
    args.stopPropagation();

    if (!confirm(`Deseja realmente deletar o usuário ${user.firstname}`))
      return;

    this.http.delete('user', { id: user.id, company_id: user.company_id })
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.getUsers();
            this.snackbar.open('Usuário deletado com sucesso!', 'OK', { duration: 3000 });
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  getAdminUser(){
    const data = {
      companyId: this.currentUser.company_id
    }
    this.http.list('company:getAdmin', data)
      .subscribe(
        (result:any) => {
          this.adminUser = result.data.companyemail;
        },
        err => this.errorReport.showMessage(err)
      )

  }

}
